<template>
  <div class="footer-terms__wrapper text-tiny">
    <div class="footer-terms__legal">
      © {{ year }} "Finance Magnates CY Ltd." All rights reserved.
    </div>
    <div class="footer-terms__links">
      <a-link class="footer-terms__link" :to="linkToCookies">
        Cookie Policy
      </a-link>
      <a-link class="footer-terms__link" :to="linkToPrivacyPolicy">
        Privacy Policy
      </a-link>
      <a-link class="footer-terms__link" :to="linkToTermsOfUse">
        Terms and Conditions
      </a-link>
      <a
        href="#"
        class="footer-terms__link"
        @click.prevent="$_cmp_toggleCookiePreferencesPopup"
      >
        Manage Cookies
      </a>
    </div>
    <div class="footer-terms__do-not-sell">
      <footer-do-not-sell-link />
    </div>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import FooterDoNotSellLink from '@/components/_layout/AFooter/FooterDoNotSellLink'

export default {
  name: 'FooterTerms',
  components: { FooterDoNotSellLink },
  mixins: [mixins.cmp],
  data() {
    const domain = this.$helper.removeEndingSlashes(this.$env.FM_DOMAIN_URL)

    return {
      year: new Date().getFullYear(),
      linkToTermsOfUse: `${domain}/terms-of-use/`,
      linkToCookies: `${domain}/cookies/`,
      linkToPrivacyPolicy: `${domain}/privacy/`
    }
  }
}
</script>

<style lang="scss" scoped>
$links-wrapping-custom-breakpoint: 450px;

.footer-terms__wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  $margin-top: (
    $above-desktop-xl: 64px,
    $tablet: 32px
  );

  @include setStyleByBreakpoint('margin-top', $margin-top);

  @include tablet {
    flex-direction: column;
  }

  .footer-terms__legal {
    $order: (
      $above-desktop-xl: 1,
      $tablet: 2
    );

    @include setStyleByBreakpoint('order', $order);

    @include tablet {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .footer-terms__links {
    display: flex;

    $order: (
      $above-desktop-xl: 2,
      $tablet: 1
    );

    @include setStyleByBreakpoint('order', $order);

    @include tablet {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 32px;
    }

    @include mobile {
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 515px;
    }

    @media (max-width: $links-wrapping-custom-breakpoint) {
      margin-right: -8px;
    }

    .footer-terms__link {
      @include mobile {
        margin-right: 8px;

        &:last-child {
          margin: 0;
        }
      }

      @media (max-width: $links-wrapping-custom-breakpoint) {
        &:last-child {
          width: 100%;
          text-align: center;
          margin-top: 12px;
        }
      }
    }
  }

  .footer-terms__link {
    $margin-right: (
      $above-desktop-xl: 48px,
      $desktop-sm: 24px,
      $tablet: 12px,
      $mobile: 0
    );

    @include setStyleByBreakpoint('margin-right', $margin-right);
  }

  .footer-terms__do-not-sell {
    flex-basis: 100%;
    order: 3;
    margin-top: 16px;
  }
}
</style>
